import { forwardRef } from 'react';

import { Button, HStack, Text } from '@betterment/samba-react';

import { RoundedBorderBox } from '~/b4b/features/plan-benchmark/components/RoundedBorderBox';

import AiOrb from './assets/icon_ai_orb.svg';

export const PlanBenchmarkButton = forwardRef<HTMLDivElement, React.ComponentPropsWithoutRef<'div'>>((props, ref) => (
  <RoundedBorderBox ref={ref} borderStyle="gradientRotateForever" borderRadius={20} {...props}>
    <Button
      variant="textSecondary"
      data-track-event="ElementClicked"
      data-track-name="SeeBenchmark"
      data-track-module="Insights"
      data-track-flow="HomeLanding"
      css={{
        borderRadius: '20px',
        textDecoration: 'none',
        background: 'none',
        width: 'size.full',
        padding: '1px',
      }}
    >
      <HStack
        css={{
          px: 'space.150',
          py: 'space.100',
          borderRadius: '20px',
          background: 'background.surface',
          gap: 'space.50',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={AiOrb} alt="AI Icon" />
        <Text variant="text50" color="text" css={{ fontWeight: 'medium' }}>
          Benchmark your plan
        </Text>
      </HStack>
    </Button>
  </RoundedBorderBox>
));

PlanBenchmarkButton.displayName = 'PlanBenchmarkButton';
